import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_PROFILE_REQUEST = "user/GET_PROFILE_REQUEST";
export const GET_PROFILE_SUCCESS = "user/GET_PROFILE_SUCCESS";
export const GET_PROFILEHASH_REQUEST = "user/GET_PROFILEHASH_REQUEST";
export const GET_PROFILEHASH_SUCCESS = "user/GET_PROFILEHASH_SUCCESS";
export const UPDATE_PROFILE_REQUEST = "user/UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS = "user/UPDATE_PROFILE_SUCCESS";
export const GET_PROFILE_INFO_REQUEST = "user/GET_PROFILE_INFO_REQUEST";
export const GET_PROFILE_INFO_SUCCESS = "user/GET_PROFILE_INFO_SUCCESS";
export const GET_NOTIFICATIONS_REQUEST = "user/GET_NOTIFICATIONS_REQUEST";
export const GET_NOTIFICATIONS_SUCCESS = "user/GET_NOTIFICATIONS_SUCCESS";
export const GET_UNSEEN_NOTIFICATIONS_REQUEST = "user/GET_UNSEEN_NOTIFICATIONS_REQUEST";
export const GET_UNSEEN_NOTIFICATIONS_SUCCESS = "user/GET_UNSEEN_NOTIFICATIONS_SUCCESS";
export const SET_UNREAD_STATUS_REQUEST = "user/SET_UNREAD_STATUS_REQUEST";
export const SET_UNREAD_STATUS_SUCCESS = "user/SET_UNREAD_STATUS_SUCCESS";
export const SET_SEEN_STATUS_BULK_REQUEST = "user/SET_SEEN_STATUS_BULK_REQUEST";
export const SET_SEEN_STATUS_BULK_SUCCESS = "user/SET_SEEN_STATUS_BULK_SUCCESS";
export const GET_TASKS_REQUEST = "user/GET_TASKS_REQUEST";
export const GET_TASKS_SUCCESS = "user/GET_TASKS_SUCCESS";
export const SHOW_CHALLENGE_MODAL = "user/SHOW_CHALLENGE_MODAL";
export const HIDE_CHALLENGE_MODAL = "user/HIDE_CHALLENGE_MODAL";
export const SET_CHALLENGE_MODAL_DATA = "user/SET_CHALLENGE_MODAL_DATA";
export const ADD_WHEEL_POINTS = "user/ADD_WHEEL_POINTS";
export const ADD_WHEEL_POINTS_SUCCESS = "user/ADD_WHEEL_POINTS_SUCCESS";
export const HIDE_WHEEL_POINTS_ANIMATION = "user/HIDE_WHEEL_POINTS_ANIMATION";
export const SHOW_USER_PROFILE_MODAL = "user/SHOW_USER_PROFILE_MODAL";
export const HIDE_USER_PROFILE_MODAL = "user/HIDE_USER_PROFILE_MODAL";

export const userActions = {
  getProfile: createPromiseAction(GET_PROFILE_REQUEST),
  getProfileSuccess: createAction(GET_PROFILE_SUCCESS),
  getProfileFromHash: createPromiseAction(GET_PROFILEHASH_REQUEST),
  getProfileFromHashSuccess: createAction(GET_PROFILEHASH_SUCCESS),
  updateProfile: createPromiseAction(UPDATE_PROFILE_REQUEST),
  updateProfileSuccess: createAction(UPDATE_PROFILE_SUCCESS),
  getProfileInfo: createPromiseAction(GET_PROFILE_INFO_REQUEST),
  getProfileInfoSuccess: createAction(GET_PROFILE_INFO_SUCCESS),
  getNotifications: createPromiseAction(GET_NOTIFICATIONS_REQUEST),
  getNotificationsSuccess: createAction(GET_NOTIFICATIONS_SUCCESS),
  getUnseenNotificationsCount: createPromiseAction(GET_UNSEEN_NOTIFICATIONS_REQUEST),
  getUnseenNotificationsCountSuccess: createAction(GET_UNSEEN_NOTIFICATIONS_SUCCESS),
  setUnreadStatus: createPromiseAction(SET_UNREAD_STATUS_REQUEST),
  setUnreadStatusSuccess: createAction(SET_UNREAD_STATUS_SUCCESS),
  setSeenStatusBulk: createPromiseAction(SET_SEEN_STATUS_BULK_REQUEST),
  setSeenStatusBulkSuccess: createAction(SET_SEEN_STATUS_BULK_SUCCESS),
  getTasks: createPromiseAction(GET_TASKS_REQUEST),
  getTasksSuccess: createAction(GET_TASKS_SUCCESS),
  showChallengeModal: createAction(SHOW_CHALLENGE_MODAL),
  hideChallengeModal: createAction(HIDE_CHALLENGE_MODAL),
  setChallengeModalData: createAction(SET_CHALLENGE_MODAL_DATA),
  addWheelPoints: createPromiseAction(ADD_WHEEL_POINTS),
  addWheelPointsSuccess: createAction(ADD_WHEEL_POINTS_SUCCESS),
  hideWheelPointsAnimation: createAction(HIDE_WHEEL_POINTS_ANIMATION),
  showUserProfileModal: createAction(SHOW_USER_PROFILE_MODAL),
  hideUserProfileModal: createAction(HIDE_USER_PROFILE_MODAL),
};
